export type Tome = {
  numeral: string
  label: string
  title: string
  description: string
  cover: string
}

export type Bonus = {
  n: string
  title: string
  subtitle: string
  price: string
  seal: string
  cover: string
}

export const tomes: Tome[] = [
  {
    numeral: '壹',
    label: 'Tomo I',
    title: 'El Mapa de los Meridianos Maestros',
    description:
      'Los 12 meridianos principales y los 8 vasos extraordinarios. Cada meridiano con su visual anatómico completo, recorrido marcado punto a punto, tabla clínica de referencia rápida y reloj biológico de actividad.',
    cover: 'https://cdn.magicpatterns.com/uploads/gzYo2Bf4xcsykTet8kAtFa/Portada_tomo_1.png',
  },
  {
    numeral: '貳',
    label: 'Tomo II',
    title: 'Protocolos de Respuesta Inmediata',
    description:
      '26 patologías organizadas en 6 secciones clínicas. Cada protocolo con imagen anatómica del área tratada, puntos exactos marcados sobre la ilustración, técnica específica, diagnóstico diferencial según la MTC y contraindicaciones.',
    cover: 'https://cdn.magicpatterns.com/uploads/sgxdgenoFPoqdSybN5wTJ6/Portada_tomo_2.png',
  },
  {
    numeral: '參',
    label: 'Tomo III',
    title: 'El Arte de la Aguja',
    description:
      'Técnicas maestras de manipulación: De-Qi, tonificación, dispersión, moxa, electroacupuntura, seguridad clínica y el camino del terapeuta maestro.',
    cover: 'https://cdn.magicpatterns.com/uploads/k8apin79CobFvjkkEHL6jo/Portada_tomo_3.png',
  },
]

export const bonuses: Bonus[] = [
  {
    n: '01',
    title: 'El Canal del Infinito',
    subtitle: 'Fisiología Energética y Reloj Biológico de los Meridianos',
    price: 'USD 10',
    seal: '氣',
    cover: 'https://cdn.magicpatterns.com/uploads/9HkX94kz6wwmiqHCL96Nji/Portada_bono_1.png',
  },
  {
    n: '02',
    title: 'Psicosomática Oriental',
    subtitle: 'El Mapa de las Emociones Atrapadas y los 5 Elementos',
    price: 'USD 10',
    seal: '心',
    cover: 'https://cdn.magicpatterns.com/uploads/6go1e9K32z6mTmiRZPSVep/Portada_bono_2.png',
  },
  {
    n: '03',
    title: 'Maestría en Manipulación',
    subtitle: 'Ciencia, Intención y Técnica de la Presión Energética',
    price: 'USD 11',
    seal: '手',
    cover: 'https://cdn.magicpatterns.com/uploads/bBFXd5y3MmDVkFNmDCqbPe/Portada_bono_3.png',
  },
  {
    n: '04',
    title: 'Alquimia a través del Calor',
    subtitle: 'Termoterapia y Moxibustión aplicada a los Puntos Maestros',
    price: 'USD 8',
    seal: '灸',
    cover: 'https://cdn.magicpatterns.com/uploads/5d4SaxCnypRmwonboVmLxV/Portada_bono_4.png',
  },
  {
    n: '05',
    title: 'Auriculoterapia Clínica',
    subtitle:
      'El microsistema del pabellón auricular: el mando a distancia de tu salud',
    price: 'USD 8',
    seal: '耳',
    cover: 'https://cdn.magicpatterns.com/uploads/83mBYrHWzncsWBVMogLkVy/Portada_bono_5_.png',
  },
  {
    n: '06',
    title: 'Farmacopea Externa',
    subtitle:
      'Sinergia holística: aceites esenciales y plantas aplicadas a los Puntos Maestros',
    price: 'USD 8',
    seal: '藥',
    cover: 'https://cdn.magicpatterns.com/uploads/oRicG8jExaVtz2DYVNKguk/Portada_bono_6.png',
  },
]

export const bonusesTotalValue = 'USD 55'
